module.exports = __webpack_public_path__ + "img/Card_block_bad_bot.6e674236.png";